import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
  IAPI_RET007_Request,
  IAPI_RET007_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照API
// API仕様書_法人職員
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};
// 「被共済職員退職届、退職手当金請求書、合算制度利用申出書」の取り下げ更新
// API仕様書_退職者
const httpAPI_RET007 = async (
  param: IAPI_RET007_Request
): Promise<IAPI_RET007_Response> => {
  let res = await http.post(ApiUrl.API_RET007, {
    ...param,
  });
  return res.data;
};
export { httpAPI_STA003, httpAPI_RET007 };
